import React, { useState, useEffect, useContext } from 'react'
import './styles.scss'
import { prepareNameData, preparePopulationData } from './functions'
import { NameChart } from 'components/NameChart'
import Button from '@material-ui/core/Button'
import { MultiSelect } from 'components/MultiSelect'
import LocalesContext from 'components/_locales/localeContext'

const curvecolors = [
  'var(--red-main)',
  'var(--petrol-main)',

  'var(--yellow)',
  'var(--orange-main)',
  'var(--green-main)',
  'var(--purple-main)'
]
interface Props {
  data: [
    populationdataElementRaw[],
    womenMenDataElement[],
    womenMenDataElement[]
  ]
}
export const NameComparission = ({ data }: Props) => {
  const [drawData, setDrawData] = useState<namedataElement[]>()
  const [selected, setSelected] = useState<namedataElement[]>([])
  const __l: localesInterface = useContext<localesInterface>(LocalesContext)
  useEffect(() => {
    if (!data || !data[0] || !data[1] || !data[2]) return
    let pop = data[0]
    let women = data[2]
    let men = data[1]
    const popdata: populationdataset = preparePopulationData(pop)
    const womensdata: namedateset = prepareNameData(women, popdata, 'w')
    const mensdata: namedateset = prepareNameData(men, popdata, 'm')
    const namedata = womensdata.concat(mensdata)
    setDrawData(namedata)
    setSelected(
      namedata
        .filter(f => __l.namecomp.preset.indexOf(f.name) !== -1)
        .sort((a, b) => a.name.localeCompare(b.name))
    )
  }, [])

  const handleRemove = (e: any) => {
    setSelected(selected.filter(f => f.name !== e.currentTarget.value))
  }
  const handleSelect = t => {
    setSelected([...JSON.parse(JSON.stringify(selected)), t])
  }

  return (
    <div className='NameChart'>
      <div className='ui text container'>
        <div className='title'>
          Beliebtheitsentwicklung der Vornamen in der Schweiz
        </div>
        <div className='sub'>
          Anzahl Vornamen pro Jahrgang der lebenden Bevölkerung
        </div>
      </div>
      {drawData && drawData.length > 0 && (
        <>
          <div className=' ui text container nameholder'>
            <MultiSelect
              data={drawData
                .filter(f => selected.indexOf(f) === -1)
                .sort((a, b) => {
                  return a.name.localeCompare(b.name)
                })}
              formatOption={d => (
                <>
                  <img
                    src={require('images/icons_' + d.gender + '.svg')}
                    width='12px'
                  />{' '}
                  {d.name}
                </>
              )}
              label={__l.namecomp.label}
              selected={handleSelect}
              disabled={selected.length >= 6}
              placeholder={
                selected.length >= 6
                  ? __l.namecomp.placeholder[0]
                  : __l.namecomp.placeholder[1]
              }
              startsWidth
            />
          </div>{' '}
          <div className=' ui container nameholder'>
            <div className='selectedNames'>
              <NameSelectedList elements={selected} remove={handleRemove} />
            </div>
          </div>
          <NameChart data={drawData} selected={selected} colors={curvecolors} />
        </>
      )}
    </div>
  )
}

const NameSelectedList = ({
  elements,
  remove
}: {
  elements: namedataElement[]
  remove: (e: any) => void
}) => {
  return (
    <>
      {elements.map((e, i) => {
        return (
          <NameButton
            key={i}
            name={e.name}
            color={curvecolors[i]}
            remove={remove}
          />
        )
      })}
    </>
  )
}
const NameButton = ({
  name,
  color,
  remove
}: {
  name: string
  color: string
  remove: (e: any) => void
}) => {
  return (
    <Button
      variant='contained'
      color='primary'
      style={{
        color: '#202346',
        backgroundColor: color,
        display: 'inline-block',
        textTransform: 'none',
        padding: '.5em',
        fontSize: '1.1em',
        textAlign: 'left',
        letterSpacing: '1px',
        width: window.innerWidth < 600 ? 'calc(50% - .25em)' : 'auto',
        marginBottom: '.5em',
        borderRadius: '0.2em',
        marginRight: '.5em',
        whiteSpace: 'nowrap',
        lineHeight: 0
        // boxShadow: '0'
      }}
      onClick={remove}
      value={name}
    >
      <div className='nameContainer'>{name}</div>
      <img
        src={require('images/legende_close.png')}
        width='12px'
        style={{
          marginTop: '0.15em',
          float: 'right',
          opacity: 0.6,
          marginLeft: window.innerWidth < 600 ? '0' : '1em'
        }}
      />
    </Button>
  )
}
